import { initializeApp } from 'firebase/app';
import { getAuth, RecaptchaVerifier } from 'firebase/auth';

// Firebase configuration
// These should be set in your .env file at the project root
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'shilpani',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Debug: Log Firebase config (remove in production)
if (process.env.NODE_ENV === 'development') {
  console.log('Firebase Config:', {
    apiKey: firebaseConfig.apiKey ? `${firebaseConfig.apiKey.substring(0, 10)}...` : 'MISSING',
    authDomain: firebaseConfig.authDomain,
    projectId: firebaseConfig.projectId,
    appId: firebaseConfig.appId ? `${firebaseConfig.appId.substring(0, 10)}...` : 'MISSING',
    messagingSenderId: firebaseConfig.messagingSenderId
  });
  
  // Check if all required fields are present
  const missingFields = [];
  if (!firebaseConfig.apiKey) missingFields.push('apiKey');
  if (!firebaseConfig.authDomain) missingFields.push('authDomain');
  if (!firebaseConfig.projectId) missingFields.push('projectId');
  if (!firebaseConfig.appId) missingFields.push('appId');
  
  if (missingFields.length > 0) {
    console.error('⚠️ Missing Firebase config fields:', missingFields);
    console.error('Please check your .env file in src/frontend-user/.env');
  } else {
    console.log('✅ All Firebase config fields are present');
  }
}

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize reCAPTCHA verifier
export const setupRecaptcha = (elementId = 'recaptcha-container') => {
  return new RecaptchaVerifier(auth, elementId, {
    size: 'invisible',
    callback: (response) => {
      // reCAPTCHA solved, allow signInWithPhoneNumber
      console.log('reCAPTCHA verified');
    },
    'expired-callback': () => {
      // Response expired, ask user to solve reCAPTCHA again
      console.log('reCAPTCHA expired');
    }
  });
};

export default app;

